import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, TableRow, Table, FormControl,
    TableHead, TableBody, InputLabel, Select, MenuItem, TableCell, Popper, Box,
} from "@material-ui/core";

import * as Yup from 'yup';
import { Grid, TextField } from "@material-ui/core";
import { Alert, AlertTitle } from '@material-ui/lab';
import { useFormik } from 'formik';
import ParkService from "./Locality/Service/parkService";

import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import UserService from "./Locality/Service/userService";
import DialogContentText from '@material-ui/core/DialogContentText';
// import 'date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function User() {
    const tableHeaders = ['Park','Name', 'Email', 'Phone', 'Stall Name', 'Stall Number', 'Status','Edit', 'Delete'];

    const classes = useStyles();
    const [userList, setUserList] = useState([]);
    const [age, setAge] = React.useState('');
    // const [branchIdList, setBranchIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [parkList, setParkList] = useState([]);
    const [qrCode, setQrCode] = useState([]);
    const [anchorEl, setAnchorEl] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [user, setUser] = useState({
        name: '',
        email: '',
        phone: '',
        password:'',
        status:'',
        parkId:'',
        stallName: '',
        stallNumber: '',
    })
    const [formValues, setFormValues] = useState([{ excutiveOfficerMobile: "", excutiveOfficerName: "",counterNumber:''  }]);

    const getValidationSchema = () => {
        return Yup.object().shape({
            name: Yup.string().required('Name is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            phone: Yup.string()
                .required('Phone is required')
                .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits'),
            password: user._id ? Yup.string() : Yup.string().required('Password is required'),
            status: Yup.string().required('Status is required'),
            parkId: Yup.string().required('Park name is required'),
            stallName: Yup.string(),
            stallNumber: Yup.string(),
        });
    };

    useEffect(() => {
        getParkList();
        getUserList();
        return () => {
            setUserList([]);
            setParkList([]);
        }
    }, []);

    // Auto-select park and set status when park list is loaded and dialog is open for adding
    useEffect(() => {
        if (parkList.length === 1 && open && !user._id) {
            setUser(prevUser => {
                // Only update if parkId is not already set
                if (!prevUser.parkId) {
                    return {
                        ...prevUser,
                        parkId: parkList[0]._id,
                        status: prevUser.status === '' || prevUser.status === false ? true : prevUser.status
                    };
                }
                return prevUser;
            });
        }
    }, [parkList.length, open]);
    const handleOpen = (status) => {
        if(status){
            // Set default values: status = Active (true), and parkId if only one park exists
            const defaultParkId = parkList.length === 1 ? parkList[0]._id : '';
            setUser({
                name: '',
                email: '',
                phone: '',
                password:'',
                status: true, // Default to Active
                parkId: defaultParkId, // Auto-select if only one park
                stallName: '',
                stallNumber: '',
        })
        }
        setErrorMessage('');
        setSuccessMessage('');
        setOpen(true);
    };
    // const handleOpen = () => {
    //     setOpen(true);
    // };
    const handleOpen1 = () => {
        setOpen1(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleChange = (i, e) => {
        const newFormValues = [...formValues];
        newFormValues[i][e.target.name] = e.target.value;
        setFormValues(newFormValues);
    };
    const addFormFields = () => {
        setFormValues([...formValues, { excutiveOfficerMobile: "", excutiveOfficerName: "",counterNumber:'' }]);
        console.log(formValues);
    };

    const removeFormFields = (i) => {
        const newFormValues = [...formValues];
        if (i !== 0) {
            newFormValues.splice(i, 1);
            setFormValues(newFormValues);
        } else if (i === 0 && newFormValues.length === 1) {
            setFormValues([{ type: "", name: "" }]);
        } else if (i === 0 && newFormValues.length > 1) {
            newFormValues.shift();
            setFormValues(newFormValues);
        }
    };
    const getParkList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        console.log(userDetails.role)

        const result = userDetails.role === "admin" ? null : userDetails.profileId;
        ParkService.addAllProfileId({ profileRegistrationId: result }).then((res) => {
            setParkList(res);
            // If only one park exists and user is being added (not editing), set it as default
            if (res && res.length === 1 && !user._id) {
                setUser(prevUser => ({
                    ...prevUser,
                    parkId: res[0]._id,
                    status: true
                }));
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
  
    const getUserList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));


        const result = userDetails.role === "admin" ? null : userDetails.profileId;
        UserService.getUser({ profileRegistrationId: result }).then((res) => {
            setUserList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const getProfileId = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     const result = userDetails.role === "admin" ? null : userDetails.profileId;
    //     BranchService.addAllProfileId({ profileRegistrationId: result }).then((res) => {
    //         setBranchList(res);

    //     }).catch((err) => {
            
    //     });
    // }

    const editUser = (user) => {
        // Extract parkId - handle both object (populated) and string (ID) cases
        const parkId = user.parkId?._id || user.parkId || '';
        
        setUser({
            ...user,
            parkId: parkId
        });
        handleOpen();
    }
    const deleteUser = (userdelete) => {
        if (userdelete) {
            UserService.deleteUser(userdelete).then((res) => {
                // getClinicList();
                // getProfileId()
                getUserList()
            }).catch((err) => {
            });
        }
    };
  
    const formik = useFormik({
        initialValues: user,
        enableReinitialize: true,
        validationSchema: getValidationSchema(),
        onSubmit: (values, { resetForm }) => {
            setErrorMessage('');
            setSuccessMessage('');
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            if (user._id) {
            UserService.upadeUser(values).then((res) => {
                // Check if response contains error message
                if (res.data && res.data.message && (res.data.message.toLowerCase().includes('error') || res.data.message.toLowerCase().includes('already exists'))) {
                    setErrorMessage(res.data.message);
                    return;
                }
                getUserList();
                resetForm();
                setSuccessMessage("User Updated Successfully.");
                alert("User Updated Successfully.");
                setTimeout(() => {
                    handleClose();
                }, 1500);
              })
                .catch((err) => {
                  let errorMsg = 'An error occurred while updating user.';
                  if (err.response?.data?.message) {
                    errorMsg = err.response.data.message;
                  } else if (err.response?.data?.error) {
                    errorMsg = err.response.data.error;
                  } else if (typeof err.response?.data === 'string') {
                    errorMsg = err.response.data;
                  } else if (err.message) {
                    errorMsg = err.message;
                  }
                  console.error('Update user error:', err);
                  setErrorMessage(errorMsg);
                })
            }
            else {
                UserService.registerWithProvider(values).then((res) => {
                        // Check if response contains error message
                        if (res.data && res.data.message && (res.data.message.toLowerCase().includes('error') || res.data.message.toLowerCase().includes('already exists'))) {
                            setErrorMessage(res.data.message);
                            return;
                        }
                        getUserList();
                        resetForm();
                        setSuccessMessage("User Added Successfully.");
                        alert("User Added Successfully.");
                        setTimeout(() => {
                            handleClose();
                        }, 1500);
                    })
                        .catch((err) => {
                            let errorMsg = 'An error occurred while adding user.';
                            if (err.response?.data?.message) {
                                errorMsg = err.response.data.message;
                            } else if (err.response?.data?.error) {
                                errorMsg = err.response.data.error;
                            } else if (typeof err.response?.data === 'string') {
                                errorMsg = err.response.data;
                            } else if (err.message) {
                                errorMsg = err.message;
                            }
                            console.error('Add user error:', err);
                            setErrorMessage(errorMsg);
                        })
                }
        },
    });

    return (

        <>
            <PageTitle title="User" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(112, 57, 177)' }}> Add User
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>

                        <Table className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userList.map((user) => (

                                    <TableRow key={user._id}>
                                        <TableCell className="pl-3 fw-normal" >{user.parkId?.parkName}</TableCell>
                                        
                                        <TableCell className="pl-3 fw-normal" >{user.name}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{user.email}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{user.phone}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{user.stallName || '-'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{user.stallNumber || '-'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{user.status?"Active":"In Active"}</TableCell>
                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editUser(user)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteUser(user)} />
                                        </TableCell>

                                      
                        

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        {/* {branchUserList.map(({ _id, cityName }) => (
                  <MenuItem key={_id} value={_id}>{cityName}</MenuItem>
                ))} */}
                        
                    </Widget>
                </Grid>
            </Grid>
           
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>{user._id ? 'Edit User' : 'Add User'}</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ padding: '20px 24px' }}>
                        {errorMessage && (
                            <Alert 
                                severity="error" 
                                onClose={() => setErrorMessage('')} 
                                style={{ marginBottom: 16, width: '100%' }}
                            >
                                <strong>Error:</strong> {errorMessage}
                            </Alert>
                        )}
                        {successMessage && (
                            <Alert 
                                severity="success" 
                                onClose={() => setSuccessMessage('')} 
                                style={{ marginBottom: 16, width: '100%' }}
                            >
                                {successMessage}
                            </Alert>
                        )}
                        <FormControl variant="standard" fullWidth style={{ marginBottom: 16 }}>
                            <InputLabel id="demo-simple-select-label">Select Park</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="parkId"
                                label="Select Park"
                                onChange={e => { formik.handleChange(e); }}
                                value={formik.values.parkId}
                                error={formik.touched.parkId && Boolean(formik.errors.parkId)}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {parkList.map((parkDet) => (
                                    <MenuItem key={parkDet._id} value={parkDet._id}>{parkDet.parkName}</MenuItem>
                                ))}
                            </Select>
                            {formik.touched.parkId && formik.errors.parkId && (
                                <div style={{ color: '#f44336', fontSize: '0.75rem', marginTop: 4, marginLeft: 14 }}>
                                    {formik.errors.parkId}
                                </div>
                            )}
                        </FormControl>
                        <TextField
                            fullWidth
                            autoFocus
                            margin="dense"
                            id="name"
                            name="name"
                            label="Name"
                            type="text"
                            variant="standard"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                            style={{ marginBottom: 8 }}
                        />
                        <TextField
                            fullWidth
                            margin="dense"
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            variant="standard"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            style={{ marginBottom: 8 }}
                        />
                        <TextField
                            fullWidth
                            margin="dense"
                            id="phone"
                            name="phone"
                            label="Contact Number"
                            type="text"
                            variant="standard"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                            helperText={formik.touched.phone && formik.errors.phone}
                            style={{ marginBottom: 8 }}
                        />
                        <TextField
                            fullWidth
                            margin="dense"
                            id="stallName"
                            name="stallName"
                            label="Stall Name"
                            type="text"
                            variant="standard"
                            value={formik.values.stallName || ''}
                            onChange={formik.handleChange}
                            error={formik.touched.stallName && Boolean(formik.errors.stallName)}
                            helperText={formik.touched.stallName && formik.errors.stallName}
                            style={{ marginBottom: 8 }}
                        />
                        <TextField
                            fullWidth
                            margin="dense"
                            id="stallNumber"
                            name="stallNumber"
                            label="Stall Number"
                            type="text"
                            variant="standard"
                            value={formik.values.stallNumber || ''}
                            onChange={formik.handleChange}
                            error={formik.touched.stallNumber && Boolean(formik.errors.stallNumber)}
                            helperText={formik.touched.stallNumber && formik.errors.stallNumber}
                            style={{ marginBottom: 8 }}
                        />
                        <TextField
                            fullWidth
                            margin="dense"
                            id="password"
                            name="password"
                            label={user._id ? "Password (leave blank to keep current)" : "Password"}
                            type="password"
                            variant="standard"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            style={{ marginBottom: 8 }}
                        />
                        <FormControl variant="standard" fullWidth style={{ marginBottom: 8 }}>
                            <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="status"
                                name="status"
                                value={formik.values.status}
                                label="Status"
                                onChange={formik.handleChange}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>In Active</MenuItem>
                            </Select>
                            {formik.touched.status && formik.errors.status && (
                                <div style={{ color: '#f44336', fontSize: '0.75rem', marginTop: 4, marginLeft: 14 }}>
                                    {formik.errors.status}
                                </div>
                            )}
                        </FormControl>
                        <br></br>
                        
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" color="primary" variant="contained">
                            {user._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


